'use client';

import { CACHE_TAG } from '@qlevr/shared/constants';
import { deleteCartCookie, getCartCookie } from '@qlevr/shared/providers';
import { ShopifyService } from '@qlevr/shared/services';
import {
  getCountryCodeShopify,
  getCountryFromCountryLocale,
  getLanguageCodeShopify,
  getLocaleFromCountryLocale,
  isProduction,
} from '@qlevr/shared/utilities';
import isEmpty from 'lodash.isempty';
import { useParams } from 'next/navigation';
import { useEffect } from 'react';

/* eslint-disable-next-line */
export interface DeleteExistingCartIdProps {}

export function DeleteExistingCartId(props: DeleteExistingCartIdProps) {
  const { locale } = useParams<{ locale: string }>();
  useEffect(() => {
    const fetchCart = async () => {
      const getExistingCartCookie = await getCartCookie();

      if (!getExistingCartCookie) {
        return;
      }

      const country = getCountryCodeShopify(getCountryFromCountryLocale(locale));
      const language = getLanguageCodeShopify(getLocaleFromCountryLocale(locale));

      const res = await ShopifyService({ cache: 'no-store', tags: [CACHE_TAG.cart] }).getCart({
        country,
        language,
        cartId: getExistingCartCookie,
      });

      if (!isProduction()) {
        console.log('Cart', res);
      }

      if (!res.cart || isEmpty(res.cart.lines)) {
        deleteCartCookie();
      }
    };

    fetchCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export default DeleteExistingCartId;
